import Vue from 'vue'
import VueRouter from 'vue-router'
import builder from './components/orch/builder'
/* eslint-disable no-unused-vars */

Vue.use(VueRouter)
const routes = [
  { path: '/', component: builder }
]

const router = new VueRouter({
  routes
})

/* eslint-disable no-new */
new Vue({
  router,
  components: {
    builder
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js